import ReservedTicketIcon from "../../../assets/images/icons/ticket-reserved-icon.svg";
// import ExpiredTicketIcon from "../../../assets/images/icons/ticket-expired.svg";
import GalleryIcon from "../../../assets/images/icons/gallery.svg";
import GameeBoyIcon from "../../../assets/images/icons/gameboy.svg";
import BookIcon from "../../../assets/images/icons/book.svg";
import EditIcon from "../../../assets/images/icons/edit-secondaryIcon.svg";
import LogoutIcon from "../../../assets/images/icons/logout-secondary-color.svg";
import InormationIcon from "../../../assets/images/icons/informationPrimaryColor.svg";
import CourtHoseIcon from "../../../assets/images/icons/courthouse.svg";
import StoreIcon from "../../../assets/images/icons/shop.svg";
import FormIcon from "../../../assets/images/icons/document-text.svg";
import BagHappy from "../../../assets/images/icons/bag-happy.svg";
import BagTimer from "../../../assets/images/icons/bag-timer.svg";
import Transactions from "../../../assets/images/icons/transaction-minus.svg";
import HubbleIcon from "../../../assets/images/icons/microscope.svg";
import HeartIcon from "../../../assets/images/icons/heart-circle.svg";
import WordGameIcon from "../../../assets/images/icons/wordgame.svg";
import MarthonIcon from "../../../assets/images/icons/marathonIcon.svg";

export const DashboardMenuItems = [
  {
    title: "خدمات",
    items: [
      // {
      //   itemName: "رزرو رویداد",
      //   itemIcon: ReservedTicketIcon,
      //   link: "/events",
      // },

      {
        itemName: "فرم ها",
        itemIcon: FormIcon,
        link: "/forms",
      },
      {
        itemName: "کارنامه ها",
        itemIcon: WordGameIcon,
        link: "/reportcards",
      },

      {
        itemName: "گزارش تصویری",
        itemIcon: GalleryIcon,
        link: "/gallery",
      },
      {
        itemName: "مراکز طرف قرارداد",
        itemIcon: StoreIcon,
        link: "/contractingStores",
      },
    ],
  },
  {
    title: "جوایز",
    items: [
      {
        itemName: "ویترین جوایز",
        itemIcon: BagHappy,
        link: "/pointshop",
      },
      {
        itemName: "سابقه جوایز",
        itemIcon: BagTimer,
        link: "/purchaselist",
      },
      {
        itemName: "تراکنش ها",
        itemIcon: Transactions,
        link: "/transactions",
      },
    ],
  },
  {
    title: "ویژه",
    items: [
      {
        itemName: "راه‌بهشت 1405",
        itemIcon: CourtHoseIcon,
        link: "https://rahebehesht.com/miniapp/rb1405",
      },
      {
        itemName: "ماراتن دانایی",
        itemIcon: MarthonIcon,
        link: `${window.location.origin}/miniapp/marathondanaie`,
      },
      {
        itemName: "کلمه بازی",
        itemIcon: WordGameIcon,
        link: "/wordGamesList",
      },
      {
        itemName: "راه‌بهشت 1404",
        itemIcon: CourtHoseIcon,
        link: "https://rahebehesht.com/miniapp/rb1404",
      },
      {
        itemName: "هابل",
        itemIcon: HubbleIcon,
        link: "/hubble",
      },
      {
        itemName: "راه‌بهشت 1403",
        itemIcon: CourtHoseIcon,
        link: "/rb1403",
        linkNewTab: true,
      },
      {
        itemName: "حلقه‌های کتاب روشنا",
        itemIcon: BookIcon,
        link: "/roshana",
      },
      {
        itemName: "جفت پوچ",
        itemIcon: GameeBoyIcon,
        link: "/match",
      },
      {
        itemName: "لیگ قرآنی",
        itemIcon: BookIcon,
        link: "/lig",
      },
      {
        itemName: "قاصدک",
        itemIcon: HeartIcon,
        link: "https://eitaa.com/Ghasedak_koodak",
        linkNewTab: true,
      },
    ],
  },
  {
    title: "کاربر",
    items: [
      {
        itemName: "ویرایش",
        itemIcon: EditIcon,
        link: "/user/update",
      },
      {
        itemName: "خروج از حساب",
        itemIcon: LogoutIcon,
        link: "",
        action: "logOut",
      },
    ],
  },
];

export const NotifcationsMenuItem = {
  title: "",
  items: [
    // {
    //   itemName: "روضه راه‌بهشت",
    //   itemIcon: CourtHoseIcon,
    //   link: "https://rahebehesht.com/miniapp/rb1404",
    // },
    {
      itemName: "فرهنگ و خانواده",
      itemIcon: CourtHoseIcon,
      link: "https://eitaa.com/msc_cul",
      linkNewTab: true
    },
    // {
    //   itemName: "ماراتن دانایی",
    //   itemIcon: MarthonIcon,
    //   link: `${window.location.origin}/miniapp/marathondanaie`,
    // },
    {
      itemName: "ویترین جوایز",
      itemIcon: BagHappy,
      link: "/pointshop",
    },
    // {
    //   itemName: "هابل",
    //   itemIcon: HubbleIcon,
    //   link: "/hubble",
    // },
    // {
    //   itemName: "جفت پوچ",
    //   itemIcon: GameeBoyIcon,
    //   link: "/match",
    // },
    // {
    //   itemName: "حلقه‌های کتاب روشنا",
    //   itemIcon: BookIcon,
    //   link: "/roshana",
    // },
    // {
    //   itemName: "اطلاع رسانی ماجرا",
    //   itemIcon: InormationIcon,
    //   link: "https://eitaa.com/majera",
    //   linkNewTab: true
    // },
    // {
    //   itemName: "گزارش تصویری",
    //   itemIcon: GalleryIcon,
    //   link: "/gallery",
    // },
    {
      itemName: "گزارش تصویری",
      itemIcon: GalleryIcon,
      link: "/gallery",
    },
    {
      itemName: "پشتیبانی آنلاین",
      itemIcon: InormationIcon,
      link: "https://eitaa.com/msc_cul_admin",
      linkNewTab: true,
    },
  ],
};
